<template>
  <div class="manageInfo">
    <!--注册信息 -->
    <div class="wrapper-box">
      <listItem :label="'旅行社中文名称'"
                :labelWidth="134"
                :ctnColor="'#333333'"
                :showRight="false">{{details.name}}</listItem>
      <rline></rline>
      <listItem :label="'旅行社英文名称'"
                :labelWidth="134"
                :ctnColor="'#333333'"
                :showRight="false">{{details.englishName || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem v-if="details.isParent == 1"
                :label="'企业性质'"
                :labelWidth="134"
                :ctnColor="'#333333'"
                :showRight="false">{{details.companyTypeStr || '暂无信息'}}</listItem>
      <rline v-if="details.isParent == 1"></rline>
      <listItem :label="'注册资本（人民币）'"
                :labelWidth="134"
                :ctnColor="'#333333'"
                :showRight="false"
                v-if="details.isParent == 1">{{details.registeredCapital}}万元</listItem>
      <rline></rline>
      <listItem :label="'企业注册日期'"
                :labelWidth="134"
                :ctnColor="'#333333'"
                :showRight="false">{{details.fundingTime || '暂无信息'}}</listItem>
    </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                details: {}
            };
        },

        computed: {},

        watch: {},

        methods: {
        },

        mounted () {
            if ((JSON.parse(localStorage.travelDetail)).travelAgencyDetails) {
                this.details = (JSON.parse(localStorage.travelDetail)).travelAgencyDetails
            }
        },
        created () { }
    };
</script>
<style scoped lang="less">
.manageInfo {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-top: 16px;
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px;
  }
}
</style>
